import { render, staticRenderFns } from "./personal-privacy.vue?vue&type=template&id=d1cf2edc&scoped=true&lang=pug&"
var script = {}
import style0 from "./personal-privacy.vue?vue&type=style&index=0&id=d1cf2edc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cf2edc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1cf2edc')) {
      api.createRecord('d1cf2edc', component.options)
    } else {
      api.reload('d1cf2edc', component.options)
    }
    module.hot.accept("./personal-privacy.vue?vue&type=template&id=d1cf2edc&scoped=true&lang=pug&", function () {
      api.rerender('d1cf2edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/personal-privacy.vue"
export default component.exports